import { connectCurrentRefinements } from "instantsearch.js/es/connectors/index.js";

// Selected filters
export const chamfrSelectedFilters = connectCurrentRefinements(
  (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;
    const container = widgetParams.container;
    const customLabels = widgetParams.customLabels || {};
    const indexClass = widgetParams.indexClass;

    if (!container) return;

    // Clear old content
    container.innerHTML = "";

    items.forEach((group) => {
      group.refinements.forEach((refinement) => {
        const attributeLabel = customLabels[refinement.attribute];
        const labelContent = attributeLabel
          ? `${attributeLabel}: ${refinement.label}`
          : `${refinement.label}`;
        const refinementIndexClass = indexClass || group.indexId;

        const li = document.createElement("li");
        li.classList.add(`index-${refinementIndexClass}`);
        li.dataset.index = group.indexId;

        li.innerHTML = `
          <span class="refinement-label">${labelContent}</span>
          <button class="filter-remove" data-attribute="${refinement.attribute}" data-value="${refinement.value}"></button>
        `;

        container.appendChild(li);

        li.querySelector("button").addEventListener("click", () => {
          refine(refinement); // This will remove the individual filter
        });
      });
    });
  }
);
